import { State } from '../../../store/state';

export const userSelector = (state: State) => state.me.user;
export const errorCodeSelector = (state: State) => state.me.errorCode;
